import { UIActionType, UIAction } from '../../actions/uiActions';

const serviceDeskDialogReducer = (state = false, action: UIAction) => {
  switch (action.type) {
    case UIActionType.TOGGLE_SERVICE_DESK_DIALOG:
      return !state;
    default:
      return state;
  }
};

export default serviceDeskDialogReducer;
